import React from 'react';
import Image from 'next/image';
import styles from './termos-de-uso.module.css';

const TermosDeUso: React.FC = () => {
  const handleNavigateToHome = () => {
    window.open('/', '_self');
  };

  return (
    <div className={styles.container}>
      <header className={styles.header}>
        <div className={styles.headerContent}>
          <Image
            src="/images/termos-de-uso/logo.webp"
            alt="GetNinjas"
            width={135}
            height={29}
            priority
            onClick={handleNavigateToHome}
            style={{
              cursor: 'pointer',
            }}
          />
        </div>
      </header>

      <section className={styles.heroSection}>
        <div className={styles.heroContent}>
          <h1>Termos e condições gerais de uso do site</h1>
          <p>Verifique aqui os termos e condições gerais de uso do GetNinjas</p>
        </div>
      </section>

      <section className={styles.contentSection}>
        <div className={styles.content}>
          <div className={styles.intro}>
            <p>
              GETNINJAS LTDA (“GetNinjas”), anônima de capital aberto, inscrita
              no CNPJ/MF sob o nº. 55.744.877/0001-89, é uma pessoa jurídica de
              direito privado prestadora de serviços de anúncios online,
              realizados entre promitentes contratantes (“Contratante”) e
              promitentes Anunciantes de serviço (“Anunciantes”), por meio do
              aplicativo e do site GetNinjas (“Plataforma”).<br></br>
              Por intermédio destes Termos e Condições Gerais de Uso (“Termos”),
              o GetNinjas apresenta aos usuários em geral, Contratantes e
              Anunciantes (em conjunto denominados “Usuários”) as condições
              essenciais para o uso dos serviços oferecidos na Plataforma.
              <br></br>
              Ao utilizar a Plataforma ou utilizar os serviços ofertados pelo
              GetNinjas, os Usuários aceitam e se submetem às condições destes
              Termos e às Políticas de Privacidade, bem como a todos os
              documentos anexos a estes.
            </p>
          </div>
          <div className={styles.section}>
            <h2>1. OBJETO</h2>
            <p>a. Os serviços objeto dos presentes Termos consistem em:</p>
            <div className={styles.subitem}>
              <p>
                i. Permitir aos Contratantes que utilizem a Plataforma para
                livremente e sem direcionamento ou interferência busquem
                orçamentos de Anunciantes;
              </p>
              <p>
                ii. O Modelo de Utilização de Moedas, apresenta os orçamentos
                requeridos pelos Contratantes aos Anunciantes (“Orçamentos”),
                que poderão oferecer ou não os seus Serviços (“Serviços”) ao
                Contratante.
              </p>
              <p>
                iii. Viabilizar o contato direto entre Anunciantes e
                Contratantes interessados em adquirir os Serviços, por meio da
                divulgação das informações de contato de uma parte à outra.
              </p>
            </div>
            <p>
              b. O GetNinjas, portanto, possibilita que os Usuários se contatem
              e negociem entre si diretamente, sem intervir no contato, na
              negociação ou na efetivação dos negócios, não sendo, nesta
              qualidade, fornecedor de quaisquer Serviços anunciados por seus
              Usuários na Plataforma.
            </p>
            <p>
              c. Na qualidade de classificado de Serviços, o GetNinjas não impõe
              ou interfere em qualquer negociação sobre condição, valor,
              qualidade, forma ou prazo da contratação entre os Contratantes e
              Anunciantes, tampouco garante a qualidade, ou entrega dos Serviços
              contratados entre os Usuários.
            </p>
            <p>
              d. Ao se cadastrar, o Usuário poderá utilizar todos os serviços
              disponibilizados na Plataforma disponíveis para sua região,
              declarando, para tanto, ter lido, compreendido e aceitado estes
              Termos.
            </p>
          </div>

          <div className={styles.section}>
            <h2>2. CAPACIDADE PARA CADASTRAR-SE:</h2>
            <p>
              a. Os serviços do GetNinjas estão disponíveis para pessoas físicas
              e pessoas jurídicas regularmente inscritas nos cadastros de
              contribuintes federal e estaduais que tenham capacidade legal para
              contratá-los. Não podem utilizá-los, assim, pessoas que não gozem
              dessa capacidade, inclusive menores de idade ou pessoas que tenham
              sido inabilitadas no GetNinjas, temporária ou definitivamente.
              Ficam, desde já, os Usuários advertidos das sanções legais
              cominadas pelo Código Civil.
            </p>
            <p>
              b. É vedada a criação de mais de um cadastro por Usuário. Em caso
              de multiplicidade de cadastros elaborados por um só Usuário, o
              GetNinjas reserva-se o direito de, a seu exclusivo critério e sem
              necessidade de prévia anuência ou comunicação aos Usuários,
              inabilitar todos os cadastros existentes e impedir eventuais
              cadastros futuros vinculados a estes.
            </p>
            <div className={styles.subitem}>
              <p>
                i. Somente será permitida a vinculação de um cadastro por CPF,
                telefone ou e-mail, não podendo haver duplicidade de dados em
                nenhum caso.
              </p>
            </div>
            <p>
              c. O GetNinjas pode unilateralmente excluir o cadastro dos
              Usuários quando verificado que a conduta do Usuário é ou será
              prejudicial ou ofensiva a outros Usuários, ao GetNinjas e seus
              funcionários ou a terceiros.
            </p>
          </div>

          <div className={styles.section}>
            <h2>3. CADASTRO</h2>
            <p>
              a. É necessário o preenchimento completo de todos os dados
              pessoais exigidos pelo GetNinjas no momento do cadastramento, para
              que o Usuário esteja habilitado a utilizar a Plataforma.
            </p>
            <p>
              b. É de exclusiva responsabilidade dos Usuários fornecer,
              atualizar e garantir a veracidade dos dados cadastrais, não
              cabendo ao GetNinjas qualquer tipo de responsabilidade civil e/ou
              criminal resultante de dados inverídicos, incorretos ou
              incompletos fornecidos pelos Usuários.
            </p>
            <p>
              c. O GetNinjas se reserva o direito de utilizar todos os meios
              válidos e possíveis para identificar seus Usuários, bem como
              solicitar dados adicionais e documentos que entenda serem
              pertinentes, a fim de conferir os dados pessoais informados.
            </p>
            <p>
              d. Caso o GetNinjas considere um cadastro, ou as informações nele
              contidas, suspeito de conter dados errôneos ou inverídicos, o
              GetNinjas se reserva o direito de suspender, temporária ou
              definitivamente, o Usuário responsável pelo cadastramento, assim
              como impedir e bloquear qualquer publicidade ou cadastro de
              Serviços, bem como cancelar anúncios publicados por este, sem
              prejuízo de outras medidas que entenda necessárias e oportunas. No
              caso de aplicação de quaisquer destas sanções, não assistirá aos
              Usuários direito a qualquer tipo de indenização ou ressarcimento
              por perdas e danos, lucros cessantes ou danos morais.
            </p>
            <p>
              e. O Usuário acessará sua conta por meio de apelido (login) e
              senha, comprometendo-se a não informar a terceiros esses dados,
              responsabilizando-se integralmente pelo uso que deles seja feito.
            </p>
            <p>
              f. O Usuário compromete-se a notificar o GetNinjas imediatamente,
              por meio dos canais de contato mantidos pelo GetNinjas na
              Plataforma, a respeito de qualquer uso não autorizado de sua
              conta. O Usuário será o único responsável pelas operações
              efetuadas em sua conta, uma vez que o acesso só será possível
              mediante a utilização de senha de seu exclusivo conhecimento.
            </p>
            <p>
              g. Em nenhuma hipótese será permitida a cessão, venda, aluguel ou
              outra forma de transferência da conta. Não se permitirá, ainda, a
              criação de novos cadastros por pessoas cujos cadastros originais
              tenham sido cancelados por infrações às políticas do GetNinjas.
            </p>
            <p>
              h. O apelido que o Usuário utiliza no GetNinjas não poderá guardar
              semelhança com o nome GetNinjas. Tampouco poderá ser utilizado
              qualquer apelido que insinue ou sugira que os Serviços serão
              prestados pelo GetNinjas ou que façam parte de promoções suas.
              Também serão eliminados apelidos considerados ofensivos ou que
              infrinjam a legislação em vigor.
            </p>
            <p>
              i. Não é permitido aos Anunciantes se apresentarem aos
              Contratantes como funcionários, Anunciantes de serviço ou
              contratados do GetNinjas, bem como utilizarem o nome, marca ou
              logo do GetNinjas. Os Contratantes entendem que os Anunciantes não
              são subordinados ao GetNinjas de nenhuma forma.
            </p>
            <p>
              j. O GetNinjas se reserva o direito de, unilateralmente e sem
              prévio aviso, recusar qualquer solicitação de cadastro e de
              cancelar um cadastro previamente aceito.
            </p>
          </div>

          <div className={styles.section}>
            <h2>4. MODIFICAÇÕES DOS TERMOS E CONDIÇÕES GERAIS</h2>
            <p>
              a. O GetNinjas poderá alterar, a qualquer tempo e a seu único e
              exclusivo critério, estes Termos. Os novos Termos entrarão em
              vigor 10 (dez) dias depois de publicados na Plataforma. No prazo
              de 5 (cinco) dias contados a partir da publicação das
              modificações, o Usuário deverá informar, por e-mail, caso não
              concorde com os termos alterados. Nesse caso, o vínculo contratual
              deixará de existir, desde que não haja contas ou dívidas em
              aberto. Não havendo manifestação no prazo estipulado,
              entender-se-á que o Usuário aceitou tacitamente os novos Termos, e
              o contrato continuará vinculando as partes.
            </p>
            <div className={styles.subitem}>
              <p>
                i. As alterações não vigorarão em relação a negociações entre
                Anunciante e Contratante já iniciados ao tempo em que tais
                alterações sejam publicadas. Apenas para estes, os Termos
                valerão com a redação anterior.
              </p>
            </div>
            <p>
              b. Os serviços oferecidos pelo Getninjas poderão ser diferentes
              para cada região do país. Estes Termos deverão ser interpretados
              de acordo com a região em que foi efetuado o cadastro do
              Anunciante.
            </p>
          </div>

          <div className={styles.section}>
            <h2>5. ACEITE DE ORÇAMENTOS</h2>
            <p>
              a. No Modelo de Utilização de Moedas, os Contratantes prestarão
              informações básicas sobre os Serviços que pretendem contratar e os
              Orçamentos serão disponibilizados aos Anunciantes que poderão, de
              livre vontade, escolher se terão acesso às informações de contato
              do Contratante.
            </p>
            <p>
              b. Os dados de contato do Contratante somente serão
              disponibilizados ao Anunciante após o desconto de um número
              pré-determinado de Moedas ("Moedas"), que poderão ser adquiridos
              pelo Anunciante.
            </p>
            <p>
              c. O Anunciante reconhece que, ao dispender Moedas para visualizar
              os dados de contato do Contratante, ele apenas pagará para ter
              acesso a estes dados, não podendo responsabilizar o GetNinjas pelo
              insucesso de uma eventual negociação com o Contratante, qualquer
              que seja o motivo, incluindo dados cadastrais desatualizados ou
              incorretos inseridos pelo Contratante.
            </p>
          </div>

          <div className={styles.section}>
            <h2>6. PRIVACIDADE DA INFORMAÇÃO</h2>
            <p>
              a. Todas as informações ou os dados pessoais prestados pelo
              Usuário do GetNinjas são protegidas para maiores informações
              consulte a Política de Privacidade do GetNinjas.
            </p>
          </div>

          <div className={styles.section}>
            <h2>7. TARIFAS</h2>
            <p>
              a. Os Anunciantes poderão adquirir Moedas resgatáveis que servirão
              como moeda virtual usada para acionar as funcionalidades da
              Plataforma GetNinjas, principalmente o acesso aos contatos dos
              Contratantes.
            </p>
            <p>
              b. As Moedas poderão ser adquiridas online no site de GetNinjas,
              pelo aplicativo do GetNinjas, ou por meio do atendimento, sendo
              claro que todas as interações com o time de atendimento serão
              gravadas e armazenadas nos termos da Política de Privacidade do
              Getninjas.
            </p>
            <p>
              c. As Moedas são pessoais e intransferíveis e estão vinculadas à
              conta do Anunciante.
            </p>
            <p>
              d. O preço e disponibilidade das Moedas e dos Orçamentos estão
              sujeitos a alterações sem aviso prévio, podendo haver variação
              dinâmica baseada em fatores como local, tipo e oferta de
              orçamentos.
            </p>
            <p>
              e. O Getninjas poderá oferecer condições especiais para a
              aquisição de moedas ou atendimento personalizado para
              profissionais que se destaquem na utilização da plataforma.
            </p>
            <p>
              f. O Anunciante é o único responsável por verificar se a
              quantidade correta de Moedas foi adicionada ou deduzida de sua
              conta durante qualquer transação. É obrigação do Anunciante
              informar o GetNinjas sobre qualquer falha ou erro.
            </p>
            <p>
              g. Em nenhum caso, Moedas bonificadas, premiadas, dadas ou de
              qualquer forma oferecidas sem custo ao Anunciante serão
              reembolsadas ou transformadas em dinheiro. O Anunciante aceita que
              o GetNinjas poderá extinguir, excluir ou reduzir as Moedas
              bonificadas e nenhuma indenização ou ressarcimento serão devidos
              neste caso.
            </p>
          </div>

          <div className={styles.section}>
            <h2>8. REGIME ESPECIAL</h2>
            <p>
              a. Desde setembro de 2019, o GetNinjas é beneficiário de Regime
              Especial para Emissão de Notas Fiscais, conforme autorização
              expedida pela Prefeitura Municipal de São Paulo nos termos dos
              Processos Administrativos nºs 6017.2020/0035465-0 e
              6017.2020/0045071-3 (“Regime Especial”).
            </p>
            <p>
              b. O Regime Especial permite ao GetNinjas emitir Notas Fiscais de
              Serviço de forma diferenciada a seus Anunciantes, fazendo-o da
              seguinte forma:
            </p>
            <p>
              (1) Anunciantes pessoa física (profissionais autônomos e MEI):
              será emitida uma única NFS-e MENSAL para cada código de serviço,
              consolidando o valor total da receita auferida, no mês, com os
              serviços prestados pelo GetNinjas; e
            </p>
            <p>
              (2) Anunciantes pessoa jurídica: será emitida uma NFS-e mensal por
              tomador pessoa jurídica e por código de serviço, consolidando o
              valor da receita auferida, no mês, com os serviços prestados a
              cada um dos tomadores pessoas jurídicas.
            </p>
            <p>
              c. Por conta da concessão do Regime Especial explicitado acima, a
              partir de janeiro de 2021, o GetNinjas passará a enviar quando
              solicitado, a seus Anunciantes, para o e-mail por eles cadastrados
              na Plataforma, RECIBOS contendo a discriminação dos serviços
              adquiridos, os valores despendidos e a data referente a essas
              transações.
            </p>
            <p>
              d. O GetNinjas disponibilizará um canal de atendimento específico,
              para maiores dúvidas acerca do procedimento que passará a ser
              adotado a partir de janeiro de 2021.
            </p>
          </div>

          <div className={styles.section}>
            <h2>9. POLÍTICA DE CANCELAMENTO</h2>
            <p>
              a. As Moedas adquiridas pelo Anunciante não serão devolvidas ao
              Anunciante ou convertidas em moeda corrente, caso o Anunciante
              decida parar de usar a Plataforma GetNinjas.
            </p>
            <p>
              b. As Moedas adquiridas terão validade de 3 (três) meses a partir
              do momento da aquisição. Após esse período, as Moedas vencidas
              serão descontadas da conta do Anunciante, que não poderá reclamar
              nenhum direito sobre elas.
            </p>
            <div className={styles.subitem}>
              <p>
                i. O GetNinjas poderá criar condições especiais de validade das
                Moedas para casos específicos ou ofertas pontuais.
              </p>
            </div>
            <p>
              c. O Anunciante que não deseje realizar a renovação automática do
              Modelo de Utilização de Moedas deverá, em até 7 (sete) dias após a
              renovação automática e apenas caso não tenha utilizado Moedas
              adquiridas em razão da renovação, informar ao GetNinjas que não
              deseja efetuar a renovação. Após esse período, será cobrada multa
              no valor de 20% do valor contratado em razão da rescisão. Caso o
              Anunciante tenha utilizado Moedas referente à renovação, não será
              permitida a rescisão.
            </p>
          </div>

          <div className={styles.section}>
            <h2>10. SERVIÇOS E ANÚNCIOS E ORÇAMENTOS PROIBIDOS</h2>
            <p>
              a. O GetNinjas é uma Plataforma de classificados online de
              Serviços, estando proibida a veiculação de qualquer anúncio ou
              pedido de orçamento de venda, aluguel, troca ou qualquer forma de
              transferência de posse ou propriedade de qualquer bem móvel ou
              imóvel.
            </p>
            <p>
              b. Estão proibidas também a veiculação de anúncios de serviços
              ilegais de acordo com a legislação vigente ou que possam ser
              considerados ofensivos a terceiros.
            </p>
            <p>
              c. O GetNinjas excluirá, unilateralmente e sem qualquer
              comunicação prévia, aquele Usuário que desrespeitar as regras
              contidas nesta seção.
            </p>
            <p>
              d. O GetNinjas não realiza uma curadoria prévia dos anúncios
              veiculados na Plataforma.
            </p>
            <p>
              e. Qualquer Usuário ou pessoa física ou jurídica que se sentir
              ofendido por qualquer anúncio veiculado na Plataforma poderá
              requisitar ao GetNinjas que exclua aquele anúncio da Plataforma,
              pelos seus canais de atendimento.
            </p>
          </div>

          <div className={styles.section}>
            <h2>11. SISTEMA DE QUALIFICAÇÃO DOS PRESTADORES</h2>
            <p>
              a. Os Anunciantes aceitam e se submetem ao sistema de qualificação
              adotado por GetNinjas.
            </p>
            <p>
              b. Os Anunciantes concordam que o GetNinjas poderá cancelar,
              excluir ou suspender por tempo indeterminado cadastros que
              apresentem qualificações negativas de forma reiterada.
            </p>
            <p>
              c. Os Anunciantes entendem que as contas são pessoais e
              intransferíveis. O GetNinjas poderá suspender ou excluir, sem
              aviso prévio, qualquer Anunciante em caso de suspeita de
              transferência, onerosa ou não, para qualquer terceiro.
            </p>
            <p>
              d. Não assistirá aos Anunciantes qualquer tipo de indenização ou
              ressarcimento por perdas e danos, lucros cessantes e danos morais,
              em razão da qualificação atribuída aos Serviços anunciados.
            </p>
            <p>
              e. Tendo em vista que os comentários postados são opiniões
              pessoais dos Usuários, estes serão responsáveis pelas opiniões
              publicadas na Plataforma, seja perante o GetNinjas, perante os
              Anunciantes, terceiros, órgãos governamentais ou demais Usuários
              do site, isentando GetNinjas de qualquer responsabilidade relativa
              à veiculação dos comentários.
            </p>
            <p>
              i. O GetNinjas não excluíra comentários ou qualificações sobre os
              Anunciantes. Somente o Usuário responsável pelo comentário ou
              qualificação poderá remover ou alterar os comentários ou
              qualificações.
            </p>
            <p>
              f. GetNinjas se reserva o direito de excluir unilateralmente e a
              seu exclusivo critério, comentários que contenham e cadastros de
              Usuários que pratiquem:
            </p>
            <div className={styles.subitem}>
              <p>
                i. Ofensa à honra, imagem, reputação e dignidade de terceiros;
              </p>
              <p>
                ii. Pornografia, pedofilia, e outras modalidades de satisfação
                sexual;
              </p>
              <p>iii. Racismo ou discriminação de qualquer natureza;</p>
              <p>
                iv. Bullying, Stalking ou qualquer outra espécie de
                constrangimento ilegal ou assédio;
              </p>
              <p>
                v. Manifesta violação a direito autoral ou direito de imagem;
              </p>
              <p>
                vi. Utilização de marcas, símbolos, logotipos ou emblemas de
                terceiros;
              </p>
              <p>
                vii. Instigação ou apologia à prática de crimes, como tráfico ou
                uso de entorpecentes, estupro, homicídio, estelionato, dentre
                outros;
              </p>
              <p>viii. Erros ou suspeita de equívocos.</p>
            </div>
          </div>

          <div className={styles.section}>
            <h2>12. OBRIGAÇÕES DOS USUÁRIOS</h2>
            <p>
              a. O Anunciante deve ter capacidade legal para prestar o Serviço.
            </p>
            <p>
              b. Em virtude do GetNinjas não figurar como parte nas transações
              de contratação dos Serviços que se realizam entre os Usuários, a
              responsabilidade por todas as obrigações delas decorrentes, sejam
              fiscais, trabalhistas, consumeristas ou de qualquer outra
              natureza, será exclusivamente do Contratante, do Anunciante ou de
              ambos, conforme o caso. Na hipótese de interpelação judicial que
              tenha como Réu o GetNinjas, cujos fatos fundem-se em ações do
              Anunciante, este será chamado ao processo, devendo arcar com todos
              os ônus que daí decorram, incluindo despesas com taxas,
              emolumentos, acordos, honorários advocatícios entre outros. Por
              não figurar como parte nas transações que se realizam entre os
              Usuários, GetNinjas também não pode obrigar os Usuários a honrarem
              suas obrigações ou a efetivarem a negociação.
            </p>
            <p>
              c. O Anunciante deverá ter em mente que, na medida em que atue
              como um fornecedor de serviços, sua oferta o vincula, nos termos
              do artigo 30 do Código de Defesa do Consumidor e do artigo 429 do
              Código Civil, cujo cumprimento poderá ser exigido judicialmente
              pelo Contratante
            </p>
            <p>
              d. O GetNinjas não se responsabiliza pelas obrigações tributárias
              que recaiam sobre as atividades dos Usuários. Assim como
              estabelece a legislação pertinente em vigor, o Contratante deverá
              exigir nota fiscal do Anunciante em suas transações. O Anunciante,
              nos moldes da lei vigente, responsabilizar-se-á pelo cumprimento
              da integralidade das obrigações oriundas de suas atividades,
              notadamente aquelas referentes a tributos incidentes.
            </p>
          </div>

          <div className={styles.section}>
            <h2>13. PRÁTICAS VEDADAS</h2>
            <p>
              a. É terminantemente vedado aos Usuários, entre outras atitudes
              previstas nestes Termos, manipular, direta ou indiretamente, os
              preços dos Serviços anunciados.
            </p>
            <p>
              b. É proibido aos Anunciantes divulgar o mesmo anúncio, conteúdo,
              item ou serviço em mais de uma categoria e/ou de forma repetida.
              GetNinjas se reserva o direito de excluir anúncios ou serviços
              repetidos, assim como suspender ou excluir o cadastro do
              Anunciante responsável pela duplicidade.
            </p>
            <p>
              c. Os Usuários não poderão: (i) Obter, guardar, divulgar,
              comercializar e/ou utilizar dados pessoais sobre outros Usuários
              para fins comerciais ou ilícitos; (ii) Usar meios automáticos,
              incluindo spiders, robôs, crawlers, ferramentas de captação de
              dados ou similares para baixar dados do site (exceto ferramentas
              de busca na Internet e arquivos públicos não comerciais); (iii)
              Burlar, ou tentar burlar, de qualquer forma que seja, o sistema,
              mecanismo e/ou a Plataforma do site; e (iv) incluir meios de
              contato como telefone, e-mail, endereço e outras formas de
              comunicação nas ofertas.
            </p>
          </div>

          <div className={styles.section}>
            <h2>14. VIOLAÇÃO NO SISTEMA OU DA BASE DE DADOS</h2>
            <p>
              a. É vedada a utilização de dispositivo, software ou outro recurso
              que possa interferir nas atividades e nas operações de Plataforma,
              bem como nos anúncios, nas descrições, nas contas ou em seus
              bancos de dados. Qualquer intromissão, tentativa de, ou atividade
              que viole ou contrarie as leis de direito de propriedade
              intelectual e as proibições estipuladas nestes Termos tornará o
              responsável passível de sofrer os efeitos das ações legais
              pertinentes, bem como das sanções aqui previstas, sendo ainda
              responsável por indenizar GetNinjas ou seus Usuários por eventuais
              danos causados.
            </p>
          </div>

          <div className={styles.section}>
            <h2>15. SANÇÕES</h2>
            <p>
              a. Sem prejuízo de outras medidas, o GetNinjas poderá, a seu
              exclusivo critério e sem necessidade de prévia anuência dos ou
              comunicação aos Usuários, advertir, suspender ou cancelar,
              temporária ou permanentemente, o cadastro ou os anúncios do
              Usuário, podendo aplicar sanção que impacte negativamente em sua
              reputação, a qualquer tempo, iniciando as ações legais cabíveis e
              suspendendo a prestação de seus serviços, se: (i) o Usuário não
              cumprir qualquer dispositivo destes Termos e as demais políticas
              do GetNinjas; (ii) descumprir com seus deveres de Usuário; (iii)
              praticar atos delituosos ou criminais; (iv) não puder ser
              verificada a identidade do Usuário, qualquer informação fornecida
              por ele esteja incorreta ou se as informações prestadas levarem a
              crer que o cadastro seja falso ou de pessoa diversa; (v) GetNinjas
              entender que os anúncios ou qualquer outra atitude do Usuário
              tenham causado algum dano a terceiros ou a GetNinjas ou tenham a
              potencialidade de assim o fazer.
            </p>
            <p>
              b. Nos casos de suspensão, temporária ou permanente, do cadastro
              do Anunciante, todos os anúncios ativos serão automaticamente
              cancelados.
            </p>
            <div className={styles.subitem}>
              <p>
                i. O Anunciante excluído ou suspenso por qualquer motivo perderá
                todas as Moedas contratadas. No caso da suspensão, caso, ao
                final da investigação do caso, a conta do Anunciante seja
                plenamente reestabelecida, as Moedas perdidas serão devolvidas
                para a conta do Anunciante.
              </p>
              <p>
                ii. Em caso de suspensão permanente ou exclusão do Anunciante em
                razão de comprovação ou suspeita de fraude contra GetNinjas ou
                Contratantes, o GetNinjas não devolverá as Moedas ou quaisquer
                valores já dispendidos pelo Anunciante.
              </p>
            </div>
            <p>
              c. O GetNinjas se reserva o direito de, a qualquer momento e a seu
              exclusivo critério, solicitar o envio de documentação pessoal ou
              de qualquer documento que comprove a veracidade das informações
              cadastrais.
            </p>
            <p>
              d. Em caso de requisição de documentos, quaisquer prazos
              determinados nestes Termos só serão aplicáveis a partir da data de
              recebimento dos documentos solicitados ao Anunciante por
              GetNinjas.
            </p>
          </div>

          <div className={styles.section}>
            <h2>16. RESPONSABILIDADES</h2>
            <p>
              a. O GetNinjas não se responsabiliza por vícios ou defeitos
              técnicos e/ou operacionais oriundos do sistema do Usuário ou de
              terceiros.
            </p>
            <p>
              b. O GetNinjas não é responsável pela entrega dos Serviços
              anunciados pelos Anunciantes na Plataforma.
            </p>
            <p>
              c. O GetNinjas tampouco se responsabiliza pela existência,
              quantidade, qualidade, estado, integridade ou legitimidade dos
              Serviços oferecidos ou contratados pelos Usuários, assim como pela
              capacidade para contratar dos Usuários ou pela veracidade dos
              dados pessoais por eles fornecidos. GetNinjas, por não ser
              proprietária, depositante ou detentora dos produtos oferecidos,
              não outorga garantia por vícios ocultos ou aparentes nas
              negociações entre os Usuários. Cada Usuário conhece e aceita ser o
              único responsável pelos Serviços que anuncia ou pelas ofertas que
              realiza.
            </p>
            <p>
              d. O Getninjas não será responsável por ressarcir seus Usuários
              por quaisquer gastos com ligações telefônicas, pacotes de dados,
              SMS, mensagens, emails, correspondência ou qualquer outro valor
              despendido pelo Usuário em razão de contato com o Getninjas ou
              quaisquer outros Usuário, por qualquer motivo que o seja.
            </p>
            <p>
              e. O GetNinjas não poderá ser responsabilizado pelo efetivo
              cumprimento das obrigações assumidas pelos Usuários. Os Usuários
              reconhecem e aceitam que, ao realizar negociações com outros
              Usuários, fazem-no por sua conta e risco, reconhecendo o GetNinjas
              como mero fornecedor de serviços de disponibilização de espaço
              virtual para anúncio dos Serviços ofertados por terceiros.
            </p>
            <p>
              f. Em nenhum caso GetNinjas será responsável pelo lucro cessante
              ou por qualquer outro dano e/ou prejuízo que o Usuário possa
              sofrer devido às negociações realizadas ou não realizadas por meio
              de Plataforma, decorrentes da conduta de outros Usuários.
            </p>
            <p>
              g. Por se tratar de negociações realizadas por meio eletrônico
              entre dois Usuários que não se conheciam previamente à negociação,
              o GetNinjas recomenda que toda transação seja realizada com
              cautela e prudência.
            </p>
            <p>
              h. Caso um ou mais Usuários ou algum terceiro inicie qualquer tipo
              de reclamação ou ação legal contra outro ou outros Usuários, todos
              e cada um dos Usuários envolvidos nas reclamações ou ações eximem
              de toda responsabilidade GetNinjas e seus diretores, gerentes,
              empregados, agentes, operários, representantes e procuradores.
            </p>
            <p>
              i. O GetNinjas se reserva o direito de auxiliar e cooperar com
              qualquer autoridade judicial ou órgão governamental, podendo
              enviar informações cadastrais ou negociais de seus Usuários,
              quando considerar que seu auxílio ou cooperação sejam necessários
              para proteger seus Usuários, funcionários, colaboradores,
              administradores, sócios ou qualquer pessoa que possa ser
              prejudicada pela ação ou omissão combatida.
            </p>
          </div>

          <div className={styles.section}>
            <h2>17. ALCANCE DOS SERVIÇOS</h2>
            <p>
              a. Estes Termos não geram nenhum contrato de sociedade, de
              mandato, de franquia ou relação de trabalho entre GetNinjas e o
              Usuário. O Usuário manifesta ciência de que o GetNinjas não é
              parte de nenhuma transação realizada entre Usuários, nem possui
              controle algum sobre a qualidade, a segurança ou a legalidade dos
              Serviços anunciados pelos Usuários, sobre a veracidade ou a
              exatidão dos anúncios elaborados pelos Usuários, e sobre a
              capacidade dos Usuários para negociar.
            </p>
            <p>
              b. O GetNinjas não pode assegurar o êxito de qualquer transação
              realizada entre Usuários, tampouco verificar a identidade ou os
              dados pessoais dos Usuários. O GetNinjas não garante a veracidade
              da publicação de terceiros que apareça em sua Plataforma e não
              será responsável pela correspondência ou por contratos que o
              Usuário realize com terceiros.
            </p>
            <div className={styles.subitem}>
              <p>
                i. O GetNinjas poderá oferecer aos Anunciantes um serviço de
                conferência, para garantir a sua identidade e dados cadastrais.
                O GetNinjas poderá informar aos Contratantes quando esse serviço
                foi utilizado pelo Anunciante.
              </p>
              <p>
                ii. O Anunciante que burlar o sistema de conferência a fim de
                receber vantagens ilícitas será excluído da Plataforma e poderão
                ser tomadas medidas judiciais cabíveis, especialmente de cunho
                criminal.
              </p>
            </div>
          </div>

          <div className={styles.section}>
            <h2>18. PROBLEMAS DECORRENTES DO USO DO SISTEMA</h2>
            <p>
              a. O GetNinjas não se responsabiliza por qualquer dano, prejuízo
              ou perda sofridos pelo Usuário em razão de falhas em sua conexão
              com a internet, com o seu provedor, no sistema, com o sistema de
              SMS, com a linha telefônica ou no servidor utilizados pelo
              Usuário, decorrentes de condutas de terceiros, caso fortuito ou
              força maior.
            </p>
            <p>
              b. O GetNinjas não é responsável pela compatibilidade entre a sua
              Plataforma e hardwares de propriedade do Usuário. O Usuário deverá
              manter o seu equipamento atualizado e não poderá responsabilizar
              GetNinjas caso a Plataforma não seja acessível em equipamentos
              antiquados.
            </p>
            <p>
              c. O GetNinjas também não será responsável por qualquer vírus,
              trojan, malware, spyware ou qualquer software que possa danificar,
              alterar as configurações ou infiltrar o equipamento do Usuário em
              decorrência do acesso, da utilização ou da navegação na internet,
              ou como consequência da transferência de dados, informações,
              arquivos, imagens, textos ou áudio.
            </p>
          </div>

          <div className={styles.section}>
            <h2>19. PROPRIEDADE INTELECTUAL E LINKS</h2>
            <p>
              a. O uso comercial da expressão "GetNinjas" como marca, nome
              empresarial ou nome de domínio, bem como os logos, marcas,
              insígnias, conteúdo das telas relativas aos serviços da Plataforma
              e o conjunto de programas, bancos de dados, redes e arquivos que
              permitem que o Usuário acesse e use sua conta, são propriedade do
              GetNinjas e estão protegidos pelas leis e pelos tratados
              internacionais de direito autoral, de marcas, de patentes, de
              modelos e de desenhos industriais. O uso indevido e a reprodução
              total ou parcial dos referidos conteúdos são proibidos, salvo com
              autorização expressa do GetNinjas.
            </p>
          </div>

          <div className={styles.section}>
            <h2>20. INDENIZAÇÃO</h2>
            <p>
              a. O Usuário indenizará o GetNinjas, suas filiais, empresas
              controladas, controladores diretos ou indiretos, diretores,
              administradores, colaboradores, representantes e empregados,
              inclusive quanto a honorários advocatícios, por qualquer demanda
              promovida por outros Usuários ou terceiros, decorrentes das
              atividades do primeiro na Plataforma, de quaisquer
              descumprimentos, por aquele, dos Termos e das demais políticas do
              GetNinjas ou, ainda, de qualquer violação, pelo Usuário, de lei ou
              de direitos de terceiros.
            </p>
          </div>

          <div className={styles.section}>
            <h2>21. LEGISLAÇÃO APLICÁVEL E FORO DE ELEIÇÃO</h2>
            <p>
              a. Todos os itens destes Termos são regidos pelas leis vigentes na
              República Federativa do Brasil. Para todos os assuntos referentes
              à interpretação, ao cumprimento ou a qualquer outro questionamento
              relacionado a estes Termos, as partes concordam em se submeter ao
              Foro da Comarca de São Paulo.
            </p>
          </div>

          <div className={styles.section}>
            <h2>22. SERVIÇOS E ANÚNCIOS E ORÇAMENTOS PROIBIDOS</h2>
            <p>
              a. O GetNinjas é uma Plataforma de classificados online de
              Serviços, estando proibida a veiculação de qualquer anúncio ou
              pedido de orçamento de venda, aluguel, troca ou qualquer forma de
              transferência de posse ou propriedade de qualquer bem móvel ou
              imóvel.
            </p>
            <p>
              b. Estão proibidas também a veiculação de anúncios de serviços
              ilegais de acordo com a legislação vigente ou que possam ser
              considerados ofensivos a terceiros.
            </p>
            <p>
              c. O GetNinjas excluirá, unilateralmente e sem qualquer
              comunicação prévia, aquele Usuário que desrespeitar as regras
              contidas nesta seção.
            </p>
            <p>
              d. O GetNinjas não realiza uma curadoria prévia dos anúncios
              veiculados na Plataforma.
            </p>
            <p>
              e. Qualquer Usuário ou pessoa física ou jurídica que se sentir
              ofendido por qualquer anúncio veiculado na Plataforma poderá
              requisitar ao GetNinjas que exclua aquele anúncio de sua
              Plataforma, pelos seus canais de atendimento.
            </p>
          </div>
        </div>
      </section>

      <footer className={styles.footer}>
        <div className={styles.footerContent}>
          <Image
            src="/images/termos-de-uso/logo.webp"
            alt="GetNinjas"
            width={135}
            height={29}
            priority
            onClick={handleNavigateToHome}
            style={{
              cursor: 'pointer',
            }}
          />
          <p>
            ©2011-2024, GetNinjas LTDA. CNPJ 55.744.877/0001-89 - Rua Dr.
            Fernandes Coelho, 85 - 3º Andar - Pinheiros - São Paulo/SP - Brasil
          </p>
        </div>
      </footer>
    </div>
  );
};

export default TermosDeUso;
